/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteMultipleTimeRegsInput = {
    ids?: Array<string | null> | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type deleteMultipleTimeRegsMutationVariables = {
    input: DeleteMultipleTimeRegsInput;
};
export type deleteMultipleTimeRegsMutationResponse = {
    readonly deleteMultipleTimeRegs: {
        readonly deletedTimeRegIds: ReadonlyArray<string | null> | null;
        readonly viewer: {
            readonly id: string;
        } | null;
        readonly errors: ReadonlyArray<string | null> | null;
    } | null;
};
export type deleteMultipleTimeRegsMutation = {
    readonly response: deleteMultipleTimeRegsMutationResponse;
    readonly variables: deleteMultipleTimeRegsMutationVariables;
};



/*
mutation deleteMultipleTimeRegsMutation(
  $input: DeleteMultipleTimeRegsInput!
) {
  deleteMultipleTimeRegs(input: $input) {
    deletedTimeRegIds
    viewer {
      id
    }
    errors
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteMultipleTimeRegsInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteMultipleTimeRegsPayload",
    "kind": "LinkedField",
    "name": "deleteMultipleTimeRegs",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedTimeRegIds",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteMultipleTimeRegsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteMultipleTimeRegsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteMultipleTimeRegsMutation",
    "operationKind": "mutation",
    "text": "mutation deleteMultipleTimeRegsMutation(\n  $input: DeleteMultipleTimeRegsInput!\n) {\n  deleteMultipleTimeRegs(input: $input) {\n    deletedTimeRegIds\n    viewer {\n      id\n    }\n    errors\n  }\n}\n"
  }
};
})();
(node as any).hash = 'e9d4cc0420d989b702a25847057d4a4f';
export default node;
